import { render } from "./customTable.vue?vue&type=template&id=0af891ae&scoped=true"
import script from "./customTable.vue?vue&type=script&lang=js"
export * from "./customTable.vue?vue&type=script&lang=js"

import "./customTable.vue?vue&type=style&index=0&id=0af891ae&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0af891ae"]])

export default __exports__